import { createUniComponentFromWebComponent } from '../../../core/utils/uni-component/uni-component.js';
import { DataViewUILogicBase } from '../../../core/view/data-view-base.js';
import type { ChartSingleView } from '../chart-view-manager.js';
import { ChartViewUI } from './chart-view-ui.js';

export class ChartViewUILogic extends DataViewUILogicBase<ChartSingleView> {
  clearSelection = () => {};

  addRow = () => undefined;

  focusFirstCell = () => {};

  showIndicator = () => false;

  hideIndicator = () => {};

  moveTo = () => {};

  renderer = createUniComponentFromWebComponent(ChartViewUI);
}
